// extracted by mini-css-extract-plugin
export var actionButton = "_iy-t";
export var buttonContainer = "_iy-0";
export var buttonContainer2 = "_iy-1";
export var buttonSection = "_iy-2";
export var details = "_iy-3";
export var dropdownItem = "_iy-5";
export var dropdownItemsContainer = "_iy-4";
export var fileInput = "_iy-r";
export var headerButton = "_iy-6";
export var icon = "_iy-7";
export var input = "_iy-8";
export var macroListItem = "_iy-9";
export var mainContent = "_iy-a";
export var microText = "_iy-b";
export var modal = "_iy-w";
export var optionsButton = "_iy-c";
export var paperclip = "_iy-s";
export var pillContent = "_iy-d";
export var preview = "_iy-e";
export var preview2 = "_iy-f";
export var quillEditor = "_iy-q";
export var selectedMacro = "_iy-g";
export var sidebar = "_iy-h";
export var sidebarHeader = "_iy-j";
export var sidebarList = "_iy-i";
export var sidebarListItem = "_iy-k";
export var sidebarSearch = "_iy-l";
export var snoozeDurationWrapper = "_iy-v";
export var statusPillContainer = "_iy-m";
export var tagsContainer = "_iy-n";
export var unselectedMacro = "_iy-o";
export var variable = "_iy-u";
export var wrapper = "_iy-p";